import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import Icon from '../../../common/Icon';
import { SubmissionContext } from '../../../../hooks/Contexts';

const SubFilesByForm = ({
  linkedForm,
  responseID,
  handleFileCopy,
  toggleCopyFileModal,
}) => {
  const { submission } = useContext(SubmissionContext);
  const linked_subs = linkedForm.linked_subs.filter(
    (s) => s.id != submission.id
  );
  const [expand, setExpand] = useState(false);
  const wrapperClass = `sub-grouping form-${linkedForm.id} ${
    expand ? '' : 'hidden'
  }`;
  const toggleDropdown = () => {
    setExpand(!expand);
  };

  if (!linked_subs.length) return <></>;
  /* linkedForm structure:
    [ 
      { 
        form: { name, id },
        linked_subs: [
          { submission: 
            { id, 
              file_responses: [ {
                field,
                response_files
              }]
            }
          }
        ]
      }
    ] */
  return (
    <>
      <h3>
        {linkedForm.name}&nbsp;
        <Icon
          icon={expand ? 'chevron-circle-up' : 'chevron-circle-down'}
          onClick={() => toggleDropdown()}
        />
      </h3>
      {linked_subs.map((link) => (
        <div className={wrapperClass} key={`linked-${link.id}`}>
          <div className='related-sub'>
            <strong>
              Submission ID: {link.id}&nbsp;
              <Link to={`/manage/submissions/${link.id}`} target='_blank'>
                <i
                  className='fa-solid fa-up-right-from-square'
                  aria-hidden='true'
                  title='Open in new tab'
                ></i>
              </Link>
            </strong>
            {!link.file_responses?.length && (
              <p>
                <i>No File fields...</i>
              </p>
            )}
            <strong>
              Submitted:{' '}
              <time dateTime={link.created_at}>
                {dayjs(link.created_at).format('MM/DD/YYYY')}
              </time>
            </strong>
          </div>
          {link.file_responses?.length > 0 && (
            <div className='related-responses'>
              {link.file_responses.map((response) => (
                <div key={`sub-${link.id} res-${response.id}`}>
                  <p className='file-field-title'>
                    <strong>{response.field.name}:</strong>
                  </p>
                  <ul>
                    {response.response_files?.length ? (
                      response.response_files.map((rf) => (
                        <li key={`rf-${rf.id}`}>
                          <p>
                            <a
                              target='_blank'
                              href={`/manage/response_files/${rf.id}`}
                              className='file-dl'
                              title='Download File'
                            >
                              <i className='fa-solid fa-download'></i>
                            </a>
                            {rf.filename}
                          </p>
                          <button
                            onClick={() =>
                              handleFileCopy(responseID, rf.id).then(
                                (result) => {
                                  if (result.ok) toggleCopyFileModal();
                                }
                              )
                            }
                          >
                            Copy
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>
                        <i>No uploads...</i>
                      </li>
                    )}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      <hr />
    </>
  );
};

export default SubFilesByForm;
